const prefix = 'Rainmakers/Signup/';

export const SIGNUP_STARTED = `${prefix}SIGNUP_STARTED`;
export const SIGNUP_DONE = `${prefix}SIGNUP_DONE`;
export const SIGNUP_ERROR = `${prefix}SIGNUP_ERROR`;

export const SIGNUP_ERRORS_CHECK = `${prefix}SIGNUP_ERRORS_CHECK`;
export const SIGNUP_ERRORS_SET = `${prefix}SIGNUP_ERRORS_SET`;
